exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".light-grey {\n  background-color: #eee !important;\n  border-color: #eee !important;\n}\ndiv.wrapper {\n  width: 100%;\n  position: relative;\n}", ""]);

// exports
